export function getMapsUrl(address: string) {
  const trimmed = address.trim();
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  const encoded = encodeURIComponent(trimmed);
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encoded}`;

  if (typeof window === "undefined") {
    return googleMapsUrl;
  }

  const isApple = /iPad|iPhone|iPod/.test(navigator.userAgent);

  return isApple
    ? `https://maps.apple.com/?q=${encoded}`
    : googleMapsUrl;
}
